// Функция отмены (undo) для истории изменений блока
export function handleUndo(blocks, zoneName, instanceId) {
  return blocks.map(block =>
    block.zone_name === zoneName
      ? {
          ...block,
          instances: block.instances.map(inst =>
            inst.id === instanceId && inst.historyIndex > 0
              ? {
                  ...inst,
                  historyIndex: inst.historyIndex - 1,
                  text: inst.history[inst.historyIndex - 1]
                }
              : inst
          )
        }
      : block
  );
}

// Функция возврата (redo) для истории изменений блока
export function handleRedo(blocks, zoneName, instanceId) {
  return blocks.map(block =>
    block.zone_name === zoneName
      ? {
          ...block,
          instances: block.instances.map(inst =>
            inst.id === instanceId && inst.historyIndex < inst.history.length - 1
              ? {
                  ...inst,
                  historyIndex: inst.historyIndex + 1,
                  text: inst.history[inst.historyIndex + 1]
                }
              : inst
          )
        }
      : block
  );
} 